export default __webpack_public_path__ + "static/silka-medium-webfont-d65646ff673ff678060198a54a1101ca.woff2";